import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
})
export class SearchComponent implements OnInit {
  @Input() placeholder = 'Szukaj...';
  @Input() value = '';
  @Input() clearLink: string;
  @Output() keyDownEmitter = new EventEmitter();
  @ViewChild('searchRef', {static: false}) searchRef: ElementRef;

  constructor() {
  }

  ngOnInit() {
  }

  onKeyDown(event) {
    this.keyDownEmitter.next(event.target.value);
  }

}
